import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

interface LeaveDetailsPageProps {}

const LeaveDetailsPage = (props: LeaveDetailsPageProps) => {
  const routes = all_routes;
  
  // Sample leave detail data - this would come from props/params in real implementation
  const leaveDetails = {
    id: 1,
    type: "Casual Leave",
    startDate: "18.08.2025",
    endDate: "18.08.2025",
    absenceHours: "5.00",
    processor: "VINAY KUMAR GUPTA",
    lastNote: "",
    reasonForLeave: "function or event ss",
    addressDuringLeave: "",
    cityDistrict: "jaipur ss",
    addressLine3: "",
    forenoonAfternoonFullDay: "AFTERNOON",
    attachments: [
      { name: "Graduation Degree.pdf", type: "pdf" },
      { name: "10th Mark sheet.jpg", type: "jpg" },
      { name: "PG Diploma.png", type: "png" }
    ]
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [fileToDelete, setFileToDelete] = useState<string | null>(null);

  const handleDeleteFile = (fileName: string) => {
    setFileToDelete(fileName);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    // Handle file deletion logic here
    console.log("Deleting file:", fileToDelete);
    setShowDeleteModal(false);
    setFileToDelete(null);
  };

  const getFileIcon = (fileType: string) => {
    switch (fileType.toLowerCase()) {
      case 'pdf':
        return 'ti ti-file-type-pdf text-danger';
      case 'jpg':
      case 'jpeg':
      case 'png':
        return 'ti ti-file-type-jpg text-primary';
      default:
        return 'ti ti-file text-secondary';
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Go Back Button */}
        <div className="mb-3">
          <Link to="/employee-leave" className="btn btn-outline-secondary">
            <i className="ti ti-arrow-left me-2"></i>
            Go Back
          </Link>
        </div>

        {/* Header */}
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Leave Overview</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.employeeDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/employee-leave">Leave Overview</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Leave Details
                </li>
              </ol>
            </nav>
          </div>
        </div>

        {/* Main Content Card */}
        <div className="card">
          <div className="card-header">
            <h4 className="card-title mb-0">Leave Overview</h4>
          </div>
          
          <div className="card-body">
            <div className="row">
              {/* Left Column */}
              <div className="col-md-6">
                {/* Type of Leave Section */}
                <div className="mb-4">
                  <h5 className="section-title border-bottom pb-2 mb-3">Type of Leave</h5>
                  <div className="mb-3">
                    <label className="form-label text-muted">Type of Leave:</label>
                    <div className="fw-medium">{leaveDetails.type}</div>
                  </div>
                </div>

                {/* General Data Section */}
                <div className="mb-4">
                  <h5 className="section-title border-bottom pb-2 mb-3">General Data</h5>
                  
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted">Start Date:</label>
                      <div className="fw-medium">{leaveDetails.startDate}</div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted">End Date:</label>
                      <div className="fw-medium">{leaveDetails.endDate}</div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted">Absence hours:</label>
                      <div className="fw-medium">{leaveDetails.absenceHours}</div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label text-muted">Processor:</label>
                      <div className="fw-medium">{leaveDetails.processor}</div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label text-muted">Last Note:</label>
                    <div className="fw-medium">{leaveDetails.lastNote || '-'}</div>
                  </div>
                </div>
              </div>

              {/* Right Column */}
              <div className="col-md-6">
                {/* Additional Data Section */}
                <div className="mb-4">
                  <h5 className="section-title border-bottom pb-2 mb-3">Additional Data</h5>
                  
                  <div className="mb-3">
                    <label className="form-label text-muted">Reason for Leave:</label>
                    <div className="fw-medium">{leaveDetails.reasonForLeave}</div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label text-muted">Address During Leave:</label>
                    <div className="fw-medium">{leaveDetails.addressDuringLeave || '-'}</div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label text-muted">City/District:</label>
                    <div className="fw-medium">{leaveDetails.cityDistrict}</div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label text-muted">Address Line 3:</label>
                    <div className="fw-medium">{leaveDetails.addressLine3 || '-'}</div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label text-muted">Forenoon/Afternoon/Full Day:</label>
                    <div className="fw-medium">{leaveDetails.forenoonAfternoonFullDay}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Attachments Section */}
            <div className="mt-4">
              <h5 className="section-title border-bottom pb-2 mb-3">Attachments</h5>
              
              <div className="border rounded p-3 bg-light">
                {leaveDetails.attachments.length > 0 ? (
                  <div className="row">
                    {leaveDetails.attachments.map((file, index) => (
                      <div key={index} className="col-md-4 mb-3">
                        <div className="d-flex align-items-center justify-content-between p-3 border rounded bg-white">
                          <div className="d-flex align-items-center">
                            <i className={`${getFileIcon(file.type)} fs-24 me-3`}></i>
                            <div>
                              <div className="fw-medium text-truncate" style={{ maxWidth: '150px' }}>
                                {file.name}
                              </div>
                              <small className="text-muted text-uppercase">{file.type}</small>
                            </div>
                          </div>
                          <div className="d-flex gap-1">
                            <button 
                              className="btn btn-sm btn-outline-primary"
                              title="Download"
                            >
                              <i className="ti ti-download"></i>
                            </button>
                            <button 
                              className="btn btn-sm btn-outline-danger"
                              title="Delete"
                              onClick={() => handleDeleteFile(file.name)}
                            >
                              <i className="ti ti-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-4">
                    <i className="ti ti-file-x fs-48 text-muted mb-2 d-block"></i>
                    <p className="text-muted mb-0">No attachments found</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="modal fade show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delete File</h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => setShowDeleteModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete <strong>{fileToDelete}</strong>?</p>
                <p className="text-muted">This action cannot be undone.</p>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => setShowDeleteModal(false)}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn btn-danger" 
                  onClick={confirmDelete}
                >
                  Delete File
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeaveDetailsPage;